import qs from 'qs';
import { useHistory, useParams } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { mobileAppConfig } from 'components/Mobile/mobileConfig';

export const useHomeQuickLinks = () => {
    const { id } = useParams<{ id: string }>();
    const contract = useProjectTreeStore((state) => state.contract);
    const project = useProjectTreeStore((state) => state.project);
    const version = useVersionStore((state) => state.version);
    const versionDbId = version?.id;
    const updateReplace = useGlobalFilterDataStore((state) => state.updateReplace);

    const history = useHistory();

    const goToActivitiesByFilter = (filters: {}) => {
        if (project && contract && versionDbId) {
            updateReplace(filters);
            const querystring = qs.stringify(filters);
            const urlParams = querystring ? `?${querystring}` : '';
            const activitiesPathWithParams = `/${AppRoutes.MOBILE}/${mobileAppConfig.activities.link}/${id}${urlParams}`;
            history.push(activitiesPathWithParams);
        }
    };

    return { goToActivitiesByFilter };
};
